exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-list[data-v-c175d0b2] {\n  height: 360px; /* or any height you want */\n  overflow-y: auto;\n}\n", ""]);

// exports
